<template>
  <div class="mb-8">
    <h2 v-if="data.title" class="text-2xl font-bold mb-4 mt-8 text-blue-700">
      {{ data.title }}
    </h2>

    <div class="flex justify-items-center overflow-x-auto">
      <button
        v-for="(button, index) in data.buttons"
        :key="index"
        @click="handleButtonClick(button)"
        class="px-4 py-2 mr-2 mt-3 bg-blue-500 text-white rounded mb-4 text-center"
      >
        {{ button.text }}
      </button>
    </div>
    <SearchComp @update-query="updateSearchQuery" />
    <div class="overflow-x-auto">
      <table class="min-w-full border border-gray-200 mr-2">
        <thead>
          <tr class="bg-gray-700 text-white">
            <th
              v-for="(header, index) in data.headers"
              :key="index"
              :class="getColumnClass(index)"
              class="px-4 py-2"
            >
              {{ header }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(row, rowIndex) in paginatedRows"
            :key="rowIndex"
            class="border-t border-gray-200"
          >
            <td
              v-for="(value, cellIndex) in Object.values(row)"
              :key="cellIndex"
              :class="getCellColumnClass(cellIndex)"
              class="px-4 py-2"
            >
              {{ value }}
            </td>
            <td class="flex">
              <button
                v-for="(option, optionIndex) in options"
                :key="optionIndex"
                @click="handleOptionClick(option, row)"
                :class="[
                  option.color,
                  'text-white',
                  'rounded-full',
                  'p-2',
                  'mr-2',
                  'mt-2',
                  'mb-2',
                  'flex',
                ]"
              >
                <span
                  :class="
                    option.icon.includes('material-symbols-outlined')
                      ? 'material-icons'
                      : option.icon.split(' ')[0]
                  "
                >
                  {{ option.icon.split(" ").pop() }}
                </span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!--Seccion de paginacion para las tablas -->
    <div class="flex justify-between items-center mt-4">
      <button
        @click="prevPage"
        :disabled="currentPage === 1"
        class="px-4 py-2 bg-blue-600 text-white rounded disabled:opacity-50"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6 inline-block align-middle"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </button>
      <div>{{ currentPage }} / {{ totalPages }}</div>
      <button
        @click="nextPage"
        :disabled="currentPage === totalPages"
        class="px-4 py-2 bg-blue-600 text-white rounded disabled:opacity-50"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6 inline-block align-middle"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 5l7 7-7 7"
          />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import SearchComp from "./SearchComp.vue";
export default {
  components: {
    SearchComp,
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({
        title: "",
        buttonText: "",
        headers: [],
        visibleColumnsMobile: [],
        ocultar: [],
        routeLink: "",
      }),
    },
    rows: {
      type: Array,
      required: true,
      default: () => [],
    },
    options: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      searchQuery: "",
      currentPage: 1,
      rowsPerPage: 8,
    };
  },
  computed: {
    filteredRows() {
      if (!this.searchQuery) return this.rows;
      return this.rows.filter((row) =>
        Object.values(row).some((value) =>
          String(value).toLowerCase().includes(this.searchQuery.toLowerCase())
        )
      );
    },
    totalPages() {
      return Math.ceil(this.filteredRows.length / this.rowsPerPage);
    },
    paginatedRows() {
      const start = (this.currentPage - 1) * this.rowsPerPage;
      const end = start + this.rowsPerPage;
      return this.filteredRows.slice(start, end);
    },
  },
  methods: {
    getColumnClass(index) {
      if (this.data.ocultar && this.data.ocultar.includes(index)) {
        return "hidden";
      }
      if (
        !this.data.visibleColumnsMobile ||
        this.data.visibleColumnsMobile.length === 0
      ) {
        return "table-cell";
      }
      return this.data.visibleColumnsMobile.includes(index)
        ? "table-cell"
        : "hidden sm:table-cell";
    },
    getCellColumnClass(index) {
      return this.getColumnClass(index);
    },
    handleButtonClick(button) {
      if (button.routeLink) {
        this.$router.push(button.routeLink);
      } else if (button.action) {
        button.action();
      }
    },
    handleOptionClick(option, row) {
      this.$emit("option-click", option.action, row);
    },
    updateSearchQuery(query) {
      this.searchQuery = query;
      this.currentPage = 1;
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
  },
};
</script>
